var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 48,
    viewBox: "0 0 59 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1925 48V33.5664C33.1925 24.5035 35.2739 17.1189 39.4366 11.4126C43.7089 5.5944 50.0078 1.79021 58.3333 0V10.9091C54.6088 11.8042 51.651 13.4825 49.4601 15.944C47.2692 18.2937 45.8451 21.1469 45.1878 24.5035H55.0469V48H33.1925ZM0 48V33.5664C0 24.5035 2.08138 17.1189 6.24413 11.4126C10.5164 5.5944 16.7606 1.79021 24.9765 0V10.9091C21.252 11.8042 18.2942 13.4825 16.1033 15.944C13.9124 18.2937 12.4883 21.1469 11.831 24.5035H21.6901V48H0Z",
    fill: "#5959C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollan);
export default __webpack_public_path__ + "static/media/collan.fa683fdfea37ad843699aa553570bb8b.svg";
export { ForwardRef as ReactComponent };